export default __webpack_public_path__ + "static/media/Rules.7e6cd3a2.jpg";